var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 전기실 관리 - 상세 사업장 List 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function SubZoneView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const isMobile = props.isMobile;
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentCurTree = props.setCurTree;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const setParentCurTabMenu = props.setCurTabMenu;
    const setParentPopWin = props.setPopWin;
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const [subZoneInfo, setSubZoneInfo] = useState(null);
    const { data: retSubZone, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/detail`,
        appQuery: { subZoneId: curTree.subZone.subZoneId },
        userToken: userInfo.loginInfo.token,
        watch: curTree.subZone.subZoneId + curTree.reload
    });
    useEffect(() => {
        if (retSubZone) {
            if (retSubZone.codeNum == CONST.API_200) {
                //clog("IN SUBZONE DETAIL : RES : " + JSON.stringify(retSubZone.body));
                setParentPopWin("pop-area-right-page-info", React.createElement(MobileSubZoneView, { curTree: curTree, subZoneInfo: retSubZone.body, onClickTreeOnOff: onClickTreeOnOff, onClickUpdateSubZone: onClickUpdateSubZone, onClickDeleteSubZone: onClickDeleteSubZone, onClickRoomInsert: onClickRoomInsert, onClickDeviceInsert: onClickDeviceInsert }));
                setSubZoneInfo(retSubZone.body);
            }
        }
    }, [curTree, retSubZone]);
    function onClickDeleteSubZone(e, subZone) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN SUBZONEVIEW : onClickDeleteSubZone : " + JSON.stringify(subZone));
            var isOk = confirm(`${subZone.subZoneName}을(를) 삭제하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "productId": subZone.subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN SUBZONE-DELETE: ret : " + JSON.stringify(data.body));
                    alert(CONST.FLD_MSG_DELETE_COMMON);
                    setParentCurTree("ZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": "", "subZoneName": "" } }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    alert(data.body.errorList[0].msg);
                }
            }
            //return data;
        });
    }
    // 사이트(ROOM) 추가
    function onClickRoomInsert(e) {
        e.stopPropagation();
        setParentWorkMode("CREATE");
        setParentAdminType("ROOM");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    // 기기등록 tab 및 목록으로 이동
    function onClickDeviceInsert(e, room) {
        e.stopPropagation();
        CUTIL.jsclose_Popup("pop-area-right-page-info");
        //mainlayout tab 데이터 확인 필요
        setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": room.roomId, "roomName": room.roomName }, spg: { "spgId": "", "spgName": "" } }));
        setParentCurTabMenu({ tabId: 1, tabName: "기기 등록 관리", tabType: "TAB_DEVICE" });
        setParentWorkMode("LIST");
        setParentAdminType("ROOM");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    function onClickTreeOnOff(e, subZone) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "product": "subzone",
                    "productId": subZone.subZoneId,
                    "approval": subZone.approval,
                    "isontree": !subZone.isontree,
                    "sort": subZone.sort
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName }, reload: true }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function onClickUpdateSubZone(e, subZone) {
        setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName }, reload: false }));
        setParentWorkMode("UPDATE");
    }
    return (React.createElement(React.Fragment, null, (subZoneInfo) &&
        React.createElement("div", { ref: mobileRef, className: "area__right" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, subZoneInfo.subZoneName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, subZoneInfo.subZoneName),
                React.createElement("div", { className: "top-button" },
                    React.createElement("button", { type: "button", className: "btn-edit", onClick: (e) => onClickUpdateSubZone(e, subZoneInfo) },
                        React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                    React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDeleteSubZone(e, subZoneInfo) },
                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                    React.createElement("ul", null,
                        (userInfo.loginInfo.role == CONST.USERROLE_ADMIN) ?
                            "" :
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "TREE"),
                                React.createElement("p", { className: `txt ${(subZoneInfo.isontree) ? "treeon" : "treeoff"}`, onClick: (e) => onClickTreeOnOff(e, subZoneInfo) },
                                    React.createElement("span", { className: "hide" }, "on"))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("p", { className: "txt" }, subZoneInfo.address)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("p", { className: "txt" }, subZoneInfo.memo)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                            React.createElement("p", { className: "txt" }, subZoneInfo.itemCount)))),
                React.createElement("div", { className: "content__list scrollH" },
                    React.createElement("div", { className: "listbox__top" },
                        React.createElement("h3", null, "\uC804\uAE30\uC2E4 \uBAA9\uB85D"),
                        React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickRoomInsert(e), "data-pop": "pop-area-right-page-info" },
                            React.createElement("span", null, "\uC804\uAE30\uC2E4 \uCD94\uAC00"))),
                    React.createElement("div", { className: "listbox__area" }, subZoneInfo.roomDto.map((room, idx) => (React.createElement("div", { key: `room_${idx.toString()}`, className: "listbox" },
                        React.createElement("div", { className: "box__top" },
                            React.createElement("p", { className: "site" }, room.roomName)),
                        React.createElement("ul", { className: "box__bottom" },
                            React.createElement("li", null,
                                React.createElement("div", null,
                                    React.createElement("p", null,
                                        React.createElement("span", null, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                                        React.createElement("strong", null, room.itemCount)),
                                    React.createElement("p", null,
                                        React.createElement("span", null, "\uAD00\uB9AC\uC790 \uC218"),
                                        React.createElement("strong", null, room.managerCount))),
                                React.createElement("button", { type: "button", className: "btn-add", "data-pop": "pop-list", onClick: (e) => onClickDeviceInsert(e, room) },
                                    React.createElement("span", null, "\uAE30\uAE30 \uB4F1\uB85D")))))))))))));
}
;
export default SubZoneView;
function MobileSubZoneView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const subZoneInfo = props.subZoneInfo;
    const onClickTreeOnOff = props.onClickTreeOnOff;
    const onClickUpdateSubZone = props.onClickUpdateSubZone;
    const onClickDeleteSubZone = props.onClickDeleteSubZone;
    const onClickRoomInsert = props.onClickRoomInsert;
    const onClickDeviceInsert = props.onClickDeviceInsert;
    return (React.createElement(React.Fragment, null, (subZoneInfo) && React.createElement("div", { className: "popup__body" },
        React.createElement("ul", { className: "page-loca" },
            React.createElement("li", null, curTree.company.companyName),
            React.createElement("li", null, curTree.zone.zoneName),
            React.createElement("li", null, subZoneInfo.subZoneName)),
        React.createElement("div", { className: "page-top" },
            React.createElement("h2", null, subZoneInfo.subZoneName),
            React.createElement("div", { className: "top-button" },
                React.createElement("button", { type: "button", className: "btn-edit", onClick: (e) => onClickUpdateSubZone(e, subZoneInfo) },
                    React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDeleteSubZone(e, subZoneInfo) },
                    React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
        React.createElement("div", { className: "area__right_content workplace__info" },
            React.createElement("div", { className: "content__info" },
                React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                React.createElement("ul", null,
                    (userInfo.loginInfo.role == CONST.USERROLE_ADMIN) ?
                        "" :
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "TREE"),
                            React.createElement("p", { className: `txt ${(subZoneInfo.isontree) ? "treeon" : "treeoff"}`, onClick: (e) => onClickTreeOnOff(e, subZoneInfo) },
                                React.createElement("span", { className: "hide" }, "on"))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                        React.createElement("p", { className: "txt" }, subZoneInfo.address)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                        React.createElement("p", { className: "txt" }, subZoneInfo.memo)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                        React.createElement("p", { className: "txt" }, subZoneInfo.itemCount)))),
            React.createElement("div", { className: "content__list scrollH" },
                React.createElement("div", { className: "listbox__top" },
                    React.createElement("h3", null, "\uC804\uAE30\uC2E4 \uBAA9\uB85D"),
                    React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickRoomInsert(e), "data-pop": "pop-area-right-page-info" },
                        React.createElement("span", null, "\uC804\uAE30\uC2E4 \uCD94\uAC00"))),
                React.createElement("div", { className: "listbox__area" }, subZoneInfo.roomDto.map((room, idx) => (React.createElement("div", { key: `room_${idx.toString()}`, className: "listbox" },
                    React.createElement("div", { className: "box__top" },
                        React.createElement("p", { className: "site" }, room.roomName)),
                    React.createElement("ul", { className: "box__bottom" },
                        React.createElement("li", null,
                            React.createElement("div", null,
                                React.createElement("p", null,
                                    React.createElement("span", null, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                                    React.createElement("strong", null, room.itemCount)),
                                React.createElement("p", null,
                                    React.createElement("span", null, "\uAD00\uB9AC\uC790 \uC218"),
                                    React.createElement("strong", null, room.managerCount))),
                            React.createElement("button", { type: "button", className: "btn-add", "data-pop": "pop-list", onClick: (e) => onClickDeviceInsert(e, room) },
                                React.createElement("span", null, "\uAE30\uAE30 \uB4F1\uB85D")))))))))))));
}
